import React from 'react'
import PropTypes from 'prop-types'

import Box from 'suitTheme/Box'
import Checkbox from 'suitTheme/Checkbox'
import ListItem from 'suitTheme/ListItem'
import Text from 'suitTheme/Text'

const SelectItem = (props) => {
  const {
    callbacks: { selectItem }, selected, title, subtitle,
  } = props

  return (
    <ListItem boxProps={{ borderBottom: '1px dashed', paddingY: 'large' }} disableHover>
      <Box alignItems="center" width="auto">
        <Checkbox checked={selected} onClick={() => selectItem()} />
      </Box>

      <Box flexDirection="column" width="auto">
        <Text fontSize="small">{title}</Text>
        {subtitle && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
            {subtitle}
          </Text>
        )}
      </Box>
    </ListItem>
  )
}

SelectItem.propTypes = {
  callbacks: PropTypes.shape({
    selectItem: PropTypes.func,
  }),
  selected: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

export default SelectItem
